import _ from 'lodash'
import { version, name } from 'package.json'
import featuresPlugin from '@blazar-plugins/features'
import viewRenderTracker from 'utils/viewRenderTracker'
import screenTypeSelector from './screenTypeSelector'

export const globalData = (state) => ({
  ...screenTypeSelector(state),
  ...{
    loginStatus: _.get(state, 'account.user.loggedIn') ? 1 : 0,
    actorId: _.toNumber(_.get(state, 'account.user.id'))
      ? _.toNumber(_.get(state, 'account.user.id'))
      : undefined,
    environment: state.config.tealium.environment,
    appName: name,
    appVersion: version,
    adblockDetected: _.toNumber(state.adBlocker.isActive),
    enabledFeatures: featuresPlugin.selectors.allEnabledFeatureNames(state) || undefined,
    renderedBy: viewRenderTracker.value,
  },
})

export default globalData
